import { ReactNode } from 'react';
import styled from '@emotion/styled';

interface ItemCardHeaderProps {
  children: ReactNode;
}

export const ItemCardHeader = ({ children }: ItemCardHeaderProps) => {
  return <HeaderContainer>{children}</HeaderContainer>;
};

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
